import { tierForExperimentSlug } from "~vue/Labs/insightCategory";
import type { LabExperiment, LabInsightWithFeedback } from "~vue/Labs/types";

export interface MyWorkInsightRenderItem {
    experiment: Pick<LabExperiment, "id" | "slug" | "title">;
    insightWithFeedback: LabInsightWithFeedback;
}

export function orderMyWorkInsights(insights: MyWorkInsightRenderItem[]): MyWorkInsightRenderItem[] {
    return [...insights].sort((a, b) => {
        const tierDifference = tierForExperimentSlug(b.experiment.slug) - tierForExperimentSlug(a.experiment.slug);
        if (tierDifference !== 0) {
            return tierDifference;
        }

        return a.insightWithFeedback.insight.title.localeCompare(b.insightWithFeedback.insight.title, undefined, {
            sensitivity: "base",
        });
    });
}
